/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  Range,
  Inverter,
} from '..';
import {
  serializeRange,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetInverterDataByRangeInput {
  serial: string;
  range: Range;
}
const build = (_query: DocumentNode, input: GetInverterDataByRangeInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.serial !== undefined ? `$serial: String = ${JSON.stringify(input.serial).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.range !== undefined ? `$range: Range = ${serializeRange(input.range)}` : '' ) + `){
    getInverterDataByRange(
      ${ input.serial !== undefined ? 'serial: $serial,' : '' } 
      ${ input.range !== undefined ? 'range: $range,' : '' }
    ){
      ...inverter
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetInverterDataByRangeQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment inverter on Inverter { ... }
   */
  async execute(_query: DocumentNode, input: GetInverterDataByRangeInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getInverterDataByRange: Partial<Inverter>[] }>({ query: build(_query, input), fetchPolicy });
  }
}
